/** Fixed permission enum (spec §5.8). Stored as strings in role_permissions. */
export const PERMISSIONS = [
    'visit.schedule',
    'visit.approve',
    'visit.check_in',
    'visit.check_out',
    'visit.admin_sign',
    'visit.edit',
    'visit.cancel',
    'visit.close',
    'visit.delete',
    'users.manage',
    'facilities.manage',
    'clusters.manage',
    'roles.manage',
    'dashboard.view',
    'reports.view',
    'export.csv',
    'settings.manage',
    'admin_sync.manage',
];
export const PERMISSION_LABELS = {
    'visit.schedule': 'Schedule visits',
    'visit.approve': 'Approve visits',
    'visit.check_in': 'Check in',
    'visit.check_out': 'Check out',
    'visit.admin_sign': 'Admin sign-off',
    'visit.edit': 'Edit visits',
    'visit.cancel': 'Cancel visits',
    'visit.close': 'Close cancelled visits',
    'visit.delete': 'Delete visits',
    'users.manage': 'Manage users',
    'facilities.manage': 'Manage facilities',
    'clusters.manage': 'Manage clusters',
    'roles.manage': 'Manage roles',
    'dashboard.view': 'View dashboard',
    'reports.view': 'View reports',
    'export.csv': 'Export CSV',
    'settings.manage': 'Manage settings',
    'admin_sync.manage': 'Entra administrator sync',
};
export const ROLE_SCOPE_TYPES = ['global', 'cluster', 'facility', 'self'];
export const BUILTIN_ROLES = [
    'Super Admin',
    'Manager',
    'Cluster Leader',
    'Administrator',
    'Delegate',
    'Field Technician',
];
/**
 * Roles that can be linked to facilities as their administrators (spec §2, §5.6). A Delegate
 * stands in when the Administrator is away: same scope, same actions, same notifications.
 */
export const FACILITY_ADMIN_ROLES = ['Administrator', 'Delegate'];
/**
 * Entra aliases that identify a facility's administrator and stand-ins (spec §5.15). The
 * reconcile job looks up `<local part>@<facility domain>` and links the account it finds.
 */
export const ADMIN_SYNC_ALIASES = [
    { localPart: 'administrator', role: 'Administrator' },
    { localPart: 'asstadministrator', role: 'Delegate' },
    { localPart: 'ait', role: 'Delegate' },
];
/**
 * Mailboxes the category push writes to (spec §5.10). Mirrors the membership of the Exchange
 * Application Access Policy group: the app has no mailbox access outside these roles.
 */
export const CATEGORY_PUSH_ROLES = [
    'Super Admin',
    'Manager',
    'Field Technician',
];
export const ROLE_SCOPE = {
    'Super Admin': 'global',
    Manager: 'global',
    'Cluster Leader': 'cluster',
    Administrator: 'facility',
    Delegate: 'facility',
    'Field Technician': 'self',
};
const MANAGER_PERMISSIONS = [
    'visit.schedule',
    'visit.approve',
    'visit.check_in',
    'visit.check_out',
    'visit.admin_sign',
    'visit.edit',
    'visit.cancel',
    'visit.close',
    'users.manage',
    'facilities.manage',
    'dashboard.view',
    'reports.view',
    'export.csv',
];
/** Administrator and Delegate share one row of the matrix; scope limits them to their facilities. */
const FACILITY_ADMIN_PERMISSIONS = [
    'visit.approve',
    'visit.check_in',
    'visit.check_out',
    'visit.admin_sign',
    'visit.cancel',
    'visit.close',
    'dashboard.view',
    'reports.view',
    'export.csv',
];
/** Default matrix from spec §5.8. Super Admin holds every permission. */
export const DEFAULT_ROLE_PERMISSIONS = {
    'Super Admin': PERMISSIONS,
    Manager: MANAGER_PERMISSIONS,
    'Cluster Leader': [
        'visit.approve',
        'visit.admin_sign',
        'dashboard.view',
        'reports.view',
        'export.csv',
    ],
    Administrator: FACILITY_ADMIN_PERMISSIONS,
    Delegate: FACILITY_ADMIN_PERMISSIONS,
    'Field Technician': [
        'visit.schedule',
        'visit.check_in',
        'visit.check_out',
        'visit.cancel',
        'visit.close',
        'dashboard.view',
        'reports.view',
        'export.csv',
    ],
};
export function isPermission(value) {
    return PERMISSIONS.includes(value);
}
export function hasPermission(granted, required) {
    return granted.includes(required);
}
//# sourceMappingURL=permissions.js.map